
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Articles",
      function () {
        return require("private-next-pages/Articles.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Articles"])
      });
    }
  